import React, { useEffect } from 'react';
import * as logger from '../utils/logger';
import { toMilliSeconds, onLaunchLive } from '../services/seek';
import { inactivity } from '../constants';
import { useTranslation } from '../hooks/translate';
import styles from './go-to-live.css';
import { ROUTES } from '../constants/routes';

/**
 * Parental PIN view.
 */
export function GoToLive({ setRoute }) {
  const [translate] = useTranslation();
  const log = logger.create('GoToLIve');

  useEffect(() => {
    log.info('Timeout after 10 seconds');

    setTimeout(() => {
      onLaunchLive();
      setRoute(ROUTES.playerLive);
    }, toMilliSeconds(inactivity.goToLive));
  }, []);

  return (
    <div className={styles.main}>
      <p className={styles.title}>{translate('readyToLiveTitle')}</p>
    </div>
  );
}
